import cortanaComposeStore from '../store/cortanaComposeStore';
import { CortanaComposeResult } from '../store/schema/CortanaComposeResult';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('addResults', function addResults(
    resultSection: string,
    results: CortanaComposeResult[]
) {
    const viewState = cortanaComposeStore.viewState;
    viewState.hasSelectableElement =
        viewState.hasSelectableElement || results.filter(element => element.selectable).length > 0;

    viewState.resultsShown.set(resultSection, results);
});
